export abstract class IAMAbstractService {
  abstract login(params?: any): Promise<void>;
  abstract getAccessToken(state: string, code: string): Promise<void>;
  abstract validateToken(): Promise<void>;
  abstract createAccount(): Promise<void>;
  abstract openForgotPasswordJourney(): Promise<void>;
}
